module.exports = __webpack_public_path__ + "img/wire-2.bd7c9c27.jpg";